webpackJsonp([43],{

/***/ "B8SX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var StopPlaySvc_1 = __webpack_require__("MT/e");
var BGVideo = (function () {
    BGVideo.$inject = ["$element", "$rootScope", "ViewPortSvc"];
    function BGVideo($element, $rootScope, ViewPortSvc) {
        var _this = this;
        this.$element = $element;
        this.$rootScope = $rootScope;
        this.ViewPortSvc = ViewPortSvc;
        this.isMobile = options.handHeld;
        this.onLoadedData = this.onLoadedData || angular.noop;
        this.handlerVideoLoaded = function (ev) {
            _this.onLoadedData({ event: ev });
            _this.$element.addClass('video-done');
        };
        setTimeout(function () {
            if (!_this.isMobile) {
                _this.stopPlaySvc = new StopPlaySvc_1.StopPlaySvc($rootScope, ViewPortSvc, $element, function (canPlay) { return canPlay ? _this.videoEl.play() : _this.videoEl.pause(); });
                _this.videoEl = _this.$element.find('video')[0];
                _this.videoEl.addEventListener('loadeddata', _this.handlerVideoLoaded);
            }
            else {
                _this.handlerVideoLoaded();
            }
        }, 0);
    }
    BGVideo.prototype.$onDestroy = function () {
        if (!this.isMobile) {
            this.stopPlaySvc.deactivate();
            this.videoEl.removeEventListener('loadeddata', this.handlerVideoLoaded);
        }
    };
    return BGVideo;
}());
exports.BGVideo = BGVideo;
angular.module('animatronApp.bgVideo', []).component('bgVideo', {
    bindings: {
        url: '<',
        onLoadedData: '&?'
    },
    transclude: true,
    controller: BGVideo,
    templateUrl: __webpack_require__("hLeG")
});


/***/ }),

/***/ "hLeG":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/bg-video_38f9ba03e95ed35fb68e725570a4de22.html";

/***/ })

});


// WEBPACK FOOTER //
// javascripts/43-82c0e6a2dceb23823569.min.js